import {
  ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector
} from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmComponent } from './confirm/confirm.component';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/do';

@Injectable()
export class PromptService {


  constructor(private appRef: ApplicationRef,
              private injector: Injector,
              private router: Router,
              private componentFactory: ComponentFactoryResolver) {
  }


  public confirm(text?: string): Observable<boolean> {
    const component = this.componentFactory.resolveComponentFactory(ConfirmComponent);

    const componentRef: ComponentRef<ConfirmComponent> = component.create(this.injector);

    this.appRef.attachView(componentRef.hostView);

    const hostView: EmbeddedViewRef<ConfirmComponent> = <EmbeddedViewRef<ConfirmComponent>>componentRef.hostView;

    componentRef.instance.text = text || '';

    const result$: Observable<boolean> = componentRef.instance.onConfirm.first().do(() => {
      componentRef.destroy();
    });

    componentRef.onDestroy(() => {
      this.appRef.detachView(hostView);
    });

    const routerStateSubscription = this.router.events.subscribe((v) => {
      routerStateSubscription.unsubscribe();
      componentRef.destroy();
    });

    document.body.appendChild(hostView.rootNodes[ 0 ]);

    return result$;
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/services/prompt/prompt.service.ts